/**
 * BOSS Reports — Save as. The name the dialog offers for a copy of a report.
 */

/** The server's limit on a report name (`BossReports."Name"` is VARCHAR(200)). */
export const MAX_REPORT_NAME = 200

/**
 * "<name> (copy)", or "(copy 2)", "(copy 3)"… when that is taken — report names are unique, and a
 * default the server refuses is a dialog the user has to fix before they can do anything. The base
 * is cut short rather than the suffix when the whole would run past the limit. Pure.
 */
export function copyNameFor(name: string, taken: Iterable<string>): string {
    const names = new Set(taken)
    const base = name.trim()
    for (let n = 1; n < 1000; n++) {
        const suffix = n === 1 ? ' (copy)' : ` (copy ${n})`
        const candidate = `${base.slice(0, MAX_REPORT_NAME - suffix.length).trimEnd()}${suffix}`
        if (!names.has(candidate)) return candidate
    }
    return base.slice(0, MAX_REPORT_NAME)
}
